import Vue from 'vue'
import VueRouter from 'vue-router'
import Admin from "@/views/Layouts/Admin"
import Auth from "@/views/Layouts/Auth"
import adminRoutes from './routes'
import store from '@/store'
import hasPermission from '@/helpers/hasPermission'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'home',
        component: Admin,
        props: true,
        children: adminRoutes,
        meta: {
            auth: true,
            title: true,
        }
    },
    {
        path: '/login',
        name: 'login',
        component: Auth,
        meta: {
            auth: false,
            title: 'Entrar'
        }
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    const firebaseToken = localStorage.getItem('firebaseToken')
    const accessToken = localStorage.getItem('accessToken')
    const isAuthenticated = !!(firebaseToken && accessToken)

    if (to.meta && to.meta.auth && !isAuthenticated) {
        next('/login')
    } else if (to.meta && !to.meta.auth && isAuthenticated) {
        next('/dashboard')
    } else if (to.meta && to.meta.permissions && isAuthenticated && !hasPermission(to.meta.permissions)) {
        next('/no-permission')
    } else {
        next()
    }
})

router.afterEach((route) => {
    Vue.nextTick(() => {
        document.title = route.meta?.title ? `Pin It - ${route.meta.title}` : 'Pin It';
    });
    store.dispatch('layout/setTitle', route.meta ? route.meta.title : '')
})

export default router
